module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_2.8eb4940c.png";